
import axios from "axios";
import { OrderPaidProduct } from "../types/types";


const ADVERTISER_ID = '51506';
const API_BASE_URL = 'https://astg.widerplanet.com/delivery/wpc.php';

export class TargetingGates {
    static sendHome() {
        console.log('[Targeting Gates] Welcome Home');
        axios
            .get(API_BASE_URL, {
                params: {
                    ti: ADVERTISER_ID,
                    ty: "Home",
                    im: "img",
                    v: 1
                }
            })
            .catch(e => console.log(e));
    }

    static sendSignIn(properties?: any) {
        console.log('[Targeting Gates] Sign In');
        axios
            .get(API_BASE_URL, {
                params: {
                    ti: ADVERTISER_ID,
                    ty: "Login",
                    im: "img",
                    v: 1,
                    mud: encodeURIComponent(JSON.stringify(properties))
                }
            })
            .catch(e => console.log(e));
    }

    static sendSignUp(properties?: any) {
        console.log('[Targeting Gates] Sign Up');
        axios
            .get(API_BASE_URL, {
                params: {
                    ti: ADVERTISER_ID,
                    ty: "Join",
                    im: "img",
                    v: 1,
                    mud: encodeURIComponent(JSON.stringify(properties))
                }
            })
            .catch(e => console.log(e));
    }

    static sendCart(properties?: any) {
        console.log('[Targeting Gates] Add to Cart');
        axios
            .get(API_BASE_URL, {
                params: {
                    ti: ADVERTISER_ID,
                    ty: "Login",
                    im: "img",
                    v: 1,
                    i: properties.i,
                    t: encodeURIComponent(properties.t)
                }
            })
            .catch(e => console.log(e));
    }

    static sendPurchase(properties?: OrderPaidProduct[]) {
        console.log('[Targeting Gates] Purchase');
        const params = "&" + properties?.map((p, index) => `i${index}=${p.productId}&t${index}=${encodeURIComponent(p.productName)}&p${index}=${p.unitPrice}&q${index}=${p.count}`).join('&');
        axios
            .get(`${API_BASE_URL}?ti=${ADVERTISER_ID}&ty=PurchaseComplete&im=img&v=1${params}`)
            .catch(e => console.log(e));
    }
}
